import { render, staticRenderFns } from "./VoiceDetectionIndicator.vue?vue&type=template&id=6ffaee73&scoped=true"
import script from "./VoiceDetectionIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./VoiceDetectionIndicator.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VoiceDetectionIndicator.vue?vue&type=style&index=0&id=6ffaee73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffaee73",
  null
  
)

export default component.exports